<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Clientes</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <customers-filter ref="filter" :active="filterActive" :searching="loading" @onSearch="onSearch"/>

    <div v-if="loading" class="m-t-20"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div v-if="!loading && infoLabel" class="ui small label m-t-15">
      <i class="info circle icon"></i>{{ infoLabel }}
    </div>

    <div v-if="$store.state.customers && $store.state.customers.length > 0" class="animated fadeIn" style="margin-top: 15px;">

      <div class="ui segment" style="padding: 20px !important;">
        <table class="ui very basic celled selectable tablet stackable table">
          <thead class="desktop-only">
            <tr>
              <th>Código</th>
              <th>Razão Social</th>
              <th>Município</th>
              <th>CNPJ</th>
              <th>Segmento</th>
              <th>Ult. Compra</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="customer in $store.state.customers" class="clickable" @click="onShowCustomer(customer)">              
              <td><strong class="mobile-only">Código: </strong>{{ customer.code + '-' + customer.unit }}</td>
              <td><strong class="mobile-only">Razão Social: </strong>
                {{ customer.name }}
                <span v-if="customer.isBlocked" class="ui small label m-l-5">
                  <i class="ban red icon"></i> Bloqueado
                </span>
              </td>
              <td><strong class="mobile-only">Município: </strong>{{ customer.city + ' / ' + customer.state }}</td>
              <td><strong class="mobile-only">CNPJ: </strong>{{ customer.formatCnpj }}</td>
              <td><strong class="mobile-only">Segmento: </strong>{{ customer.segment }}</td>
              <td><strong class="mobile-only">Ult. Compra: </strong>{{ customer.lastPurchase }}</td>
            </tr>                       
          </tbody>
        </table>
      </div>      

    </div>

  </div>

</template>

<script>
  
  import CustomersFilter from "./filter.vue"
  import CustomerService from "@/services/customer-service"

  const MAX_SEARCH_RECORDS = 100

  export default {   
    
    data() {
      return {
        loading: false,
        filterActive: true,
      }
    },

    computed: {

      infoLabel() {

        if (!this.$store.state.customers)
          return ""
        
        let label = ""
        let count = this.$store.state.customers.length

        if (count == 0) {

          label = "Nenhum registro encontrado"
        
        } else if (count == 1) {

          label = "1 registro encontrado"

        } else if (count == MAX_SEARCH_RECORDS) {

          label = "Sua pesquisa retornou o limite de registros suportados. Tente refinar os critérios de filtro."

        } else {  

          label = count + " registros encontrados"
        }

        return label
      },
    },
    
    components: {
      CustomersFilter,
    },

    created() {

      if (this.$store.state.customers && this.$store.state.customers.length > 0)
        this.filterActive = false
    },

    methods: {

      async onSearch(filter) {

        if (this.loading)
          return
        
        this.loading = true

        try {

          const customers = await CustomerService.search(filter)

          this.$store.commit("setCustomers", customers)

          this.loading = false

          if (customers.length > 0) {
            this.$refs.filter.toggleActive()
            this.$scroll.toTop()
          }  
          
        } catch (error) {
          
          this.loading = false

          this.$errorHandler(error)
        }
      },

      onShowCustomer(customer) {
        this.$router.push(`/customers/show/${customer.code}/${customer.unit}`)
      },
    },
  }

</script>

